import * as React from "react";
import { Icon as IconType } from "@tiendanube/icons";
import { Title, Text } from "../";
import "./ListItem.scss";

export interface InterfaceListItem {
  icon: IconType;
  title: string;
  text: string;
}

function ListItem({
  icon: Icon,
  title,
  text,
}: InterfaceListItem): JSX.Element {
  return (
    <div className="nimbus-web--list-item">
      <i className="nimbus-web--list-item__icon">
        <Icon size="large" />
      </i>
      <Title size="h3">{title}</Title>
      <Text size="medium">{text}</Text>
    </div>
  );
}

export default ListItem;